import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import CmnFilters from "../../lead-management/common/CmnFilters";
import {
  fetcMemberCheckinsLogData,
  fetcMemberCheckinStatsData,
} from "../../../redux/live-reducers/liveSlice";
import { fetchExportApiData } from "../../../redux/reducers/commonApiSlice";
import CheckinsWebhook from "./CheckinsWebhook";
import MemberCheckinsLog from "./MemberCheckinsLog";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../common-data/Converts";
import { getCommaSeparatedValues } from "../../pt-trials/member-report/MemberReportMocks";
// import LiveSubsStats from "../live-subs/live-subs-stats/LiveSubsStats";

const LiveMemberCheckinsLogsStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { exportData, exportLoading } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    leadAddDateFrom: FORMATTED_TODAY_DATE_YYYYMMDD,
    leadAddDateTo: FORMATTED_TODAY_DATE_YYYYMMDD,
    selectedTrainer: "",
    selAddedby: "",
    isActive: "",
    searchString: "",
    showFiltersDropdown: false,
    selectedRenewalStatus: "",
    selectedStuckStatus: "",
    selectedCheckinTime: [],
    selectedThreeDayTrialStatus: "",
    threeDayDoneDateFrom: "",
    threeDayDoneDateTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    resolved_by: allFilters.selAddedby?.value || "",
    is_resolved: allFilters.isActive?.value || "",
    is_renewal_filter: allFilters.selectedRenewalStatus?.value || "",
    three_day_done_count: allFilters.selectedThreeDayTrialStatus?.value || "",
    is_stuck: allFilters.selectedStuckStatus?.value || "",
    checkin_time_filter: "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    three_day_done_from: allFilters.threeDayDoneDateFrom || "",
    three_day_done_to: allFilters.threeDayDoneDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [csvData, setCsvData] = useState(null);

  const [statsData, setStatsData] = useState({
    total: 0,
    total_regular_members: 0,
    total_pt_member: 0,
  });
  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getCheckinsStats(filters) {
    const { page, limit, ...rest } = filters;

    dispatch(
      fetcMemberCheckinStatsData({
        filters: { ...rest },
        token: userInfoData?.token,
      })
    );
  }

  function getCheckins(filters) {
    dispatch(
      fetcMemberCheckinsLogData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getExportedData() {
    const { page, limit, ...rest } = filters;
    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint: "/attandance/daily-attendance-logs",
        payload: {
          filters: {
            ...rest,
            is_export: 1,
          },
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickExportBtn = () => {
    setCsvData(null);
    getExportedData();
  };

  useEffect(() => {
    getCheckinsStats(filters);
  }, [
    filters.gym_id,
    filters.trainer_id,
    filters.resolved_by,
    filters.is_resolved,
    filters.date_from,
    filters.date_to,
  ]);

  useEffect(() => {
    getCheckins(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      resolved_by: allFilters.selAddedby?.value || "",
      is_resolved: allFilters.isActive?.value || "",
      is_renewal_filter: allFilters.selectedRenewalStatus?.value || "",
      three_day_done_count: allFilters.selectedThreeDayTrialStatus?.value || "",
      is_stuck: allFilters.selectedStuckStatus?.value || "",
      checkin_time_filter: getCommaSeparatedValues(
        allFilters.selectedCheckinTime
      ),
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      three_day_done_from: allFilters.threeDayDoneDateFrom || "",
      three_day_done_to: allFilters.threeDayDoneDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.selAddedby,
    allFilters.isActive,
    allFilters.threeDayDoneDateFrom,
    allFilters.threeDayDoneDateTo,
    allFilters.selectedRenewalStatus,
    allFilters.selectedThreeDayTrialStatus,
    allFilters.selectedStuckStatus,
    allFilters.selectedCheckinTime,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    } else {
      setCsvData(null);
    }
  }, [exportData]);

  return (
    <Container className="bg-cloud-k px-50px" fluid>
      <Row>
        <Col>
          <CheckinsWebhook
            userInfoData={userInfoData}
            setStatsData={setStatsData}
            setAllDatas={setAllDatas}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <PageHeadingNew
            heading="Live Member Checkins Log"
            subheading="Real-time Member Checkins Logs Monitoring and Management"
            onReload={() => {
              getCheckinsStats(filters);
              getCheckins(filters);
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="member-checkin-logs"
            userInfoData={userInfoData}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickReset={onResetFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            onClickExportBtn={onClickExportBtn}
            exportLoading={exportLoading}
            csvData={csvData}
            csvFileName="member_checkins_export.csv"
          />
        </Col>
      </Row>

      {/* 
      {allFilters.showFiltersDropdown && (
        <Row>
          <Col>
            <LiveSubsStats statsData={statsData} setStatsData={setStatsData} />
          </Col>
        </Row>
      )} */}

      <Row>
        <Col>
          <MemberCheckinsLog
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            allDatas={allDatas}
            setAllDatas={setAllDatas}
            userInfoData={userInfoData}
            callFunction={() => {
              getCheckinsStats(filters);
              getCheckins(filters);
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default LiveMemberCheckinsLogsStructure;
